// extracted by mini-css-extract-plugin
export default {"modalContent":"modal-role-changing_modalContent__diFNS","modal":"modal-role-changing_modal__JsCPb"};